import moment from 'moment';

export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
export const DAY_NAMES = ['M', 'T', 'W', 'T', 'F'];
export const WEEKS_ORDER = [1, 2, 3, 4, 5, 6];
export const MONTH_ORDER = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const HEATMAP_LEGEND = {
  scale: {
    name: 'Scale',
    title: 'Change Impact Scale',
    values: ['Low', 'Medium', 'High'],
    valuesLegend: ['Low', 'Medium', 'High'],
    colorsLegend: [
      ['#84c2a6', '#5bae89', '#4a9674', '#21714d', '#174f36'],
      ['#fac575', '#f8ac3a', '#ec9109', '#c27500', '#8f5600'],
      ['#dd7a7a', '#bd4c4c', '#a42e2e', '#7f0d0d', '#600303'],
    ],
    colors: [
      [
        '#84C2A6',
        '#71B998',
        '#5BAE89',
        '#54A480',
        '#4A9674',
        '#398764',
        '#21714D',
        '#1D6243',
        '#174F36',
        '#10402B',
      ],
      [
        '#FAC575',
        '#FABB5E',
        '#F8AC3A',
        '#F3A125',
        '#EC9109',
        '#DB8606',
        '#C27500',
        '#A96501',
        '#8F5600',
        '#794900',
      ],
      [
        '#DEA6A6',
        '#D89595',
        '#CD7979',
        '#C56363',
        '#BD4C4C',
        '#AA4242',
        '#953737',
        '#862828',
        '#7A1D1D',
        '#5A1414',
      ],
    ],
  },
  perception: {
    name: 'Perception',
    title: 'Change Impact Perception',
    values: ['Positive', 'Neutral', 'Negative'],
    valuesLegend: ['Negative', 'Neutral', 'Positive'],
    colorsLegend: [
      ['#dd7a7a', '#bd4c4c', '#a42e2e', '#7f0d0d', '#600303'],
      ['#fac575', '#f8ac3a', '#ec9109', '#c27500', '#8f5600'],
      ['#84c2a6', '#5bae89', '#4a9674', '#21714d', '#174f36'],
    ],
    colors: [
      [
        '#84C2A6',
        '#71B998',
        '#5BAE89',
        '#54A480',
        '#4A9674',
        '#398764',
        '#21714D',
        '#1D6243',
        '#174F36',
        '#10402B',
      ],
      [
        '#FAC575',
        '#FABB5E',
        '#F8AC3A',
        '#F3A125',
        '#EC9109',
        '#DB8606',
        '#C27500',
        '#A96501',
        '#8F5600',
        '#794900',
      ],

      [
        '#DEA6A6',
        '#D89595',
        '#CD7979',
        '#C56363',
        '#BD4C4C',
        '#AA4242',
        '#953737',
        '#862828',
        '#7A1D1D',
        '#5A1414',
      ],
    ],
  },
};
export const generateYearObject = (year, startDate, endDate) => {
  const result = {};

  for (let month = 0; month < 12; month++) {
    const monthData = [];
    const firstDayOfMonth = new Date(year, month, 1);
    const lastDayOfMonth = new Date(year, month + 1, 0).getDate();

    const weeks = [[]];
    let currentWeek = 0;

    const offset = (firstDayOfMonth.getDay() + 6) % 7;

    for (let i = 0; i < offset; i++) {
      weeks[currentWeek].push(null);
    }

    for (let day = 1; day <= lastDayOfMonth; day++) {
      const currentDate = new Date(year, month, day);

      if (weeks[currentWeek].length === 7) {
        currentWeek++;
        weeks[currentWeek] = [];
      }

      let dayData = {};
      const startDateNew = new Date(startDate);
      const endDateNew = new Date(endDate);

      const dateToCheckDateOnly = new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        currentDate.getDate()
      );
      const startDateDateOnly = new Date(
        startDateNew.getFullYear(),
        startDateNew.getMonth(),
        startDateNew.getDate()
      );
      const endDateDateOnly = new Date(
        endDateNew.getFullYear(),
        endDateNew.getMonth(),
        endDateNew.getDate()
      );

      if (
        (!startDate || dateToCheckDateOnly >= startDateDateOnly) &&
        (!endDate || dateToCheckDateOnly <= endDateDateOnly)
      ) {
        dayData = { date: currentDate, enabled: true };
      } else {
        dayData = { date: currentDate, enabled: false };
      }

      weeks[currentWeek].push(dayData);
    }
    while (weeks[currentWeek].length < 7) {
      weeks[currentWeek].push(null);
    }

    monthData.push(...weeks);
    result[month + 1] = monthData; // Fix the month indexing
  }

  return result;
};

export const getYearsBetweenDates = (startDate, endDate) => {
  const startYear = new Date(startDate).getFullYear();
  const endYear = new Date(endDate).getFullYear();

  if (startYear > endYear) {
    return [];
  }

  const years = [];
  let currentYear = startYear;

  while (currentYear <= endYear) {
    const yearStart =
      currentYear === startYear ? startDate : `${currentYear}-01-01`;
    const yearEnd = currentYear === endYear ? endDate : `${currentYear}-12-31`;

    years.push({ year: currentYear, start: yearStart, end: yearEnd });
    currentYear++;
  }

  return years;
};

export const findImpactWithMinMaxDates = (impacts) => {
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const startDate = new Date(currentYear, 0, 1);
  const endDate = new Date(currentYear, 11, 31);
  if (impacts.length === 0) {
    return {
      minStartDateImpact: { startDate: moment(startDate).format('MM/DD/YYYY') },
      maxEndDateImpact: { endDate: moment(endDate).format('MM/DD/YYYY') },
    };
  }
  let minStartDate;
  if (impacts[0].startDate) {
    minStartDate = { ...impacts[0] };
  } else {
    minStartDate = { ...impacts[0], startDate };
  }

  let minStartDateImpact = minStartDate;
  let maxEndDateImpact = impacts[0];

  for (let i = 1; i < impacts.length; i++) {
    const currentImpact = impacts[i];
    if (currentImpact.startDate && currentImpact.endDate) {
      if (
        new Date(currentImpact.startDate) <
        new Date(minStartDateImpact.startDate)
      ) {
        minStartDateImpact = currentImpact;
      }

      if (
        new Date(currentImpact.endDate) > new Date(maxEndDateImpact.endDate)
      ) {
        maxEndDateImpact = currentImpact;
      }
    }
  }

  return {
    minStartDateImpact,
    maxEndDateImpact,
  };
};

export const getColorFill = (day, reportType, impactsNumber) => {
  const changeImpacts = {
    scales: {
      low: [],
      medium: [],
      high: [],
    },
    perceptions: {
      positive: [],
      neutral: [],
      negative: [],
    },
  };

  if (day?.impacts?.length) {
    day.impacts.forEach((impact) => {
      if (!impact.scale) return;
      changeImpacts.scales[impact.scale.toLowerCase()] = [
        ...changeImpacts.scales[impact.scale.toLowerCase()],
        impact,
      ];
    });

    day.impacts.forEach((impact) => {
      if (!impact.perception) return;
      changeImpacts.perceptions[impact.perception.toLowerCase()] = [
        ...changeImpacts.perceptions[impact.perception.toLowerCase()],
        impact,
      ];
    });
  }
  if (!day) {
    return {
      color: 'white',
      text: '',
      opacity: 25,
    };
  }
  if (day && !day.impacts.length && day.enabled) {
    return {
      color: '#ececef',
      text: '',
      opacity: 100,
    };
  }

  if (day && !day.enabled) {
    return {
      color: '#ececef',
      text: '',
      opacity: 25,
    };
  }

  const {
    low: lowMultiplier,
    medium: mediumMultiplier,
    high: highMultiplier,
  } = { low: 1, medium: 2, high: 3 };

  const calculatePriorityType = (type, keys) => {
    const sumPriority =
      changeImpacts[type][keys[0]].length * lowMultiplier +
      changeImpacts[type][keys[1]].length * mediumMultiplier +
      changeImpacts[type][keys[2]].length * highMultiplier;
    const numberCITypeValues =
      changeImpacts[type][keys[0]].length +
      changeImpacts[type][keys[1]].length +
      changeImpacts[type][keys[2]].length;

    if (!numberCITypeValues)
      return {
        color: '#ececef',
        colorSecond: '#ececef',
        colorSecondPercent: 0,
        value: keys[0],
      };

    const priorityValue = Math.ceil(sumPriority / numberCITypeValues);
    const priorityRoundUpValue = Math.ceil(priorityValue);
    const opacityValue = (day.impacts.length * 100) / impactsNumber;
    const color =
      HEATMAP_LEGEND[type === 'scales' ? 'scale' : 'perception'].colors[
        priorityRoundUpValue - 1
      ][Math.ceil(opacityValue / 10) - 1];
    const value =
      HEATMAP_LEGEND[type === 'scales' ? 'scale' : 'perception'].values[
        priorityRoundUpValue - 1
      ];

    let colorSecond = color;
    let colorSecondPercent = 0;

    const calcSecondColor = (colorIndex, multiplier) => {
      colorSecond =
        HEATMAP_LEGEND[type === 'scales' ? 'scale' : 'perception'].colors[
          colorIndex
        ][Math.ceil(opacityValue / 10) - 1];
      colorSecondPercent = (multiplier * 30) / sumPriority;
    };

    const compareValuesAndCalcColor = (
      index,
      otherIndex1,
      otherIndex2,
      multiplier1,
      multiplier2
    ) => {
      const valueLength = changeImpacts[type][keys[index]].length;
      const otherLength1 = changeImpacts[type][keys[otherIndex1]].length;
      const otherLength2 = changeImpacts[type][keys[otherIndex2]].length;

      if (valueLength * multiplier1 > otherLength2 * multiplier2) {
        calcSecondColor(otherIndex1, otherLength1 * multiplier1);
      } else if (valueLength * multiplier1 <= otherLength2 * multiplier2) {
        calcSecondColor(otherIndex2, otherLength2 * multiplier2);
      }
    };

    if (value.toLowerCase() === keys[0].toLowerCase()) {
      compareValuesAndCalcColor(0, 1, 2, mediumMultiplier, lowMultiplier);
    }

    if (value.toLowerCase() === keys[1].toLowerCase()) {
      compareValuesAndCalcColor(1, 0, 2, lowMultiplier, highMultiplier);
    }

    if (value.toLowerCase() === keys[2].toLowerCase()) {
      compareValuesAndCalcColor(2, 0, 1, lowMultiplier, mediumMultiplier);
    }

    return {
      sumPriority,
      priorityValue,
      priorityRoundUpValue,
      opacityValue,
      color,
      colorSecond,
      colorSecondPercent,
      value,
    };
  };

  const calcPriorityScale = calculatePriorityType('scales', [
    'low',
    'medium',
    'high',
  ]);
  const calcPriorityPerception = calculatePriorityType('perceptions', [
    'positive',
    'neutral',
    'negative',
  ]);

  if (day?.impacts?.length) {
    const result = {
      scale: {
        color: `color-mix(in oklab, ${calcPriorityScale.color}, ${calcPriorityScale.colorSecond} ${calcPriorityScale.colorSecondPercent}%)`,
        opacity: 100,
      },
      perception: {
        color: `color-mix(in oklab, ${calcPriorityPerception.color}, ${calcPriorityPerception.colorSecond} ${calcPriorityPerception.colorSecondPercent}%)`,
        opacity: 100,
      },
    };
    return { ...result[reportType] };
  }
};
